
import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';

import {dealInvoicesTableConfig} from '../../configs/sectionConfigs/dealInvoicesTableConfig';
import InvoicePopup from '../../popups/dealDetailPopups/InvoicePopup';
import ContainerCard from '../../../../components/ui/ContainerCard';
import {InvoiceActions, CustomerActions} from '../../../../actions';
import {notify} from '../../../../components/ui/Toast/Toast';
import Popup from '../../../../components/ui/Popup/Popup';
import Table from '../../../../components/ui/Table';

const InvoicesSection = ({
    invoicesData,
    dealData,
    refreshInvoicesData,
    buttonsDisabled,
    setButtonsDisabled,
    blueStyle,
    invoicesTableLoading,
    setInvoicesFilterQuery,
    invoicesPaginationMetadata,
    handleGetAllInvoices,
    cannotBeModified
}) => {
    const [deleteInvoiceLoading, setDeleteInvoiceLoading] = useState(null);
    const [invoicePopupView, setInvoicePopupView] = useState(false);
    const [dealRecipients, setDealRecipients] = useState({ options: [], hasNextPage: false });

    const userData = useSelector((state) => state.UserReducer.userProfileData);

    const handleGetDealRecipients = async (value) => {
        const result = await CustomerActions.getDealRecipients(userData, dealData.id);

        if (result.success) {
            // Filtrer les résultats par la recherche si nécessaire
            let filteredData = result.data;

            if (value && value.trim() !== '') {
                const searchLower = value.toLowerCase();

                filteredData = result.data.filter(item => 
                    item.name.toLowerCase().includes(searchLower)
                );
            }
            
            // Formater les données pour correspondre au format attendu par SelectInput
            setDealRecipients({
                options: filteredData,
                hasNextPage: false
            });
        }
    };

    // Charger les destinataires quand le popup s'ouvre
    useEffect(() => {
        if (invoicePopupView && dealData?.id) {
            handleGetDealRecipients('');
        }
    }, [invoicePopupView, dealData?.id]);

    const handleDeleteInvoice = async (id) => {
        setButtonsDisabled(true);
        setDeleteInvoiceLoading(id);

        const deleteInvoiceResult = await InvoiceActions.deleteInvoiceById(userData, id);

        if (!deleteInvoiceResult.success) {
            notify('Erreur lors de la suppression de la facture');
        }
        else {
            await refreshInvoicesData(true);
        }

        setDeleteInvoiceLoading(null);
        setButtonsDisabled(false);
    }

    const filterInvoiceList = async (query) => {
        setInvoicesFilterQuery(query);
    }

    const invoicesTableConfig = dealInvoicesTableConfig(
        handleDeleteInvoice,
        deleteInvoiceLoading,
        buttonsDisabled,
        blueStyle,
        filterInvoiceList,
        userData,
        cannotBeModified
    );

    return (
        <>
            <ContainerCard
                title={dealData.type === 'framework' || dealData.type === 'purchase_order' ? 'Bilan des factures' : 'Factures'}
                buttonContent='Nouvelle facture'
                onButtonClick={() => setInvoicePopupView(true)}
                blueStyle={blueStyle}
                overflow='inherit'
                coloredButtonDisplayed={!cannotBeModified && !(dealData.type === 'framework' || dealData.type === 'purchase_order')}
            >
                <Table
                    data={invoicesData}
                    tableConfig={invoicesTableConfig}
                    loading={invoicesTableLoading}
                    paginationMetadata={invoicesPaginationMetadata}
                    onPageNumberChange={handleGetAllInvoices}
                />
            </ContainerCard>

            <Popup
                view={invoicePopupView}
                setView={setInvoicePopupView}
                width={'1098px'}
                xOverflow=''
                yOverflow=''
                maxHeight='48rem'
            >
                <InvoicePopup
                    dealData={dealData}
                    setView={setInvoicePopupView}
                    refreshData={refreshInvoicesData}
                    blueStyle={blueStyle}
                    dealRecipients={dealRecipients}
                    handleGetDealRecipients={handleGetDealRecipients}
                />
            </Popup>
        </>
    )
}

export default InvoicesSection;
